<template>
  <!-- <div :class="[selectedClass === 'default' || !selectedClass ? 'table-module': selectedClass]"> -->
  <div :class="[selectedClass]">
    <table :class="mediaSize">
      <thead v-if="isHeader" class="header">
        <tr>
          <th v-for="(col, thIdx) in value.content[0].content" :key="thIdx" :class="columnMap(thIdx).colSetting" :style="colWidth(thIdx)">
            <div class="cell" :class="[{'cell-reverse': getElement(col).side === 'media-right', 'cell-column': ['media-top', 'media-center'].includes(getElement(col).side)}]">
              <template v-if="hasMedia(col)">
                <div class="media" :class="getElement(col).mediaSize">
                  <ContentGeneratorElementsMedia aspect-ratio="1/1" :value="getElement(col).media" />
                </div>
              </template>
              <ContentGeneratorElementsText v-if="!getElement(col).standalone" :content="getElement(col).text" />
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, trIdx) in content" :key="trIdx">
          <td v-for="(col, tdIdx) in row.content" :key="tdIdx" :class="columnMap(tdIdx).colSetting" :style="colWidth(tdIdx)">
            <div class="cell" :class="[{'cell-reverse': getElement(col).side === 'media-right', 'cell-column': ['media-top', 'media-center'].includes(getElement(col).side)}]">
              <template v-if="hasMedia(col)">
                <div class="media" :class="getElement(col).mediaSize">
                  <ContentGeneratorElementsMedia aspect-ratio="1/1" :value="getElement(col).media" />
                </div>
              </template>
              <ContentGeneratorElementsText v-if="!getElement(col).standalone" :content="getElement(col).text" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { contentFindContent, contentFindOption } from '../../../plugins/content'
import ContentGeneratorElementsMedia from '../elements/Media.vue'
import ContentGeneratorElementsText from '../elements/Text.vue'
export default {
  name: 'Table',
  components: {
    ContentGeneratorElementsText,
    ContentGeneratorElementsMedia
  },
  props: {
    value: { type: Object, default: null }
  },
  computed: {
    content () {
      return this.isHeader ? this.value.content.slice(1) : this.value.content
    },
    cols () {
      return contentFindOption(this.value.options, 'cols').value || null
    },
    isHeader () {
      return contentFindOption(this.value.options, 'isHeader').value || null
    },
    selectedClass () {
      return contentFindOption(this.value.options, 'selectedClass').value || null
    },
    mediaSize () {
      return contentFindOption(this.value.options, 'mediaSize').value || 'default'
    },
    columnMap () {
      return idx => (this.value.content[0].content.map((element) => {
        const unit = contentFindOption(element.options, 'unit').value || 'px'
        const colWidth = contentFindOption(element.options, 'width').value
        const colSetting = contentFindOption(element.options, 'setting').value || 'is-auto'
        return { unit, colSetting, colWidth }
      }))[idx]
    }

  },
  methods: {
    colWidth (idx) {
      const { unit, colWidth, colSetting } = this.columnMap(idx)

      if (colSetting === 'is-fixed') {
        const concatenatedWidth = colWidth + unit
        return { maxWidth: concatenatedWidth, minWidth: concatenatedWidth, width: concatenatedWidth }
      }

      if (colSetting === 'is-auto') {
        return { width: 'auto', maxWidth: '100%' }
      }

      return null
    },
    getElement (element) {
      return {
        side: contentFindOption(element.options, 'mediaPosition').value || 'media-left',
        standalone: contentFindOption(element.options, 'standalone').value,
        mediaSize: contentFindOption(element.options, 'mediaSize').value || 'default',
        text: contentFindContent(element.content, 'text'),
        media: contentFindContent(element.content, 'media')
      }
    },
    hasMedia (element) {
      const media = this.getElement(element).media
      const main = contentFindContent(media.content, 'main')
      const conditions = [
        main?.fileData?.isImage,
        main?.fileData?.isVideo?.video,
        main?.fileData?.isSvg?.url
      ]

      return conditions.some(condition => condition)
    }
  }
}

</script>

<style lang="scss" scoped>
.table {
  overflow-x: auto;

  table {
    table-layout: fixed;
    width: auto;
    min-width: 100%;

    td,th {
      border-bottom: 2px solid #eeee;
      border-right: 2px solid #eeee;
      vertical-align: middle;
      &:last-child { border-right: none; }
      &:first-child { font-weight: 600; }
    }
    th { font-weight: 600; }
    svg { width: 20px; height: 20px; }
    tr:last-child td { border-bottom: none; }
  }

  .cell {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 5px;

    &-reverse {
      flex-direction: row-reverse;
      justify-content: flex-start;
    }

    &-column {
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    :deep(.photo-wrapper) {
      img, video, .placeholder-wrapper * {
        aspect-ratio: 1/1;
      }
    }
  }

  /* Keep your existing desktop styles below */
  .cell:has(.text-container .text .textaligncenter) {
    justify-content: center;
  }
  .cell:has(.text-container .text .textalignright) {
    justify-content: flex-end;
  }

  :deep(td.is-narrow),
  :deep(th.is-narrow) {
    white-space: nowrap;
    width: 1%;
  }
  :deep(.text p) {
    hyphens: none
  }

  .header {

    background: #f1eaea;

    :deep(.text-container p) {
      font-weight: 600;

    }
  }
}

.is-auto {
  @media (min-width: 320px) {
    width: 100%;
  }

  @media (min-width: 768) {
    width: auto;
    min-width: none;
  }

}

@mixin media($width, $height, $radius, $important: false) {
  max-width: $width#{if($important, ' !important', '')};
  max-height: $height#{if($important, ' !important', '')};
  :deep(.photo-wrapper) {
    img,video, .placeholder-wrapper * {
      border-radius: $radius#{if($important, ' !important', '')};
    }
  }
}

.media {
  min-width: 50px;
  // min-width: max-content;
}

table.media-icon {
  td {
    .media {
      @include media(50px,50px, 50%);
      flex: 0 0 50px !important;
      aspect-ratio: 1/1;
    }
  }
}

table.media-big {
  td {
    .media {
      aspect-ratio: 1/1;
      flex: 0 0 300px;
      @include media(300px,300px, 20px);
    }
  }
}

// media classes
div.media-icon {
  aspect-ratio: 1/1;
  flex: 0 0 50px;
  @include media(50px,50px, 50%, true);
}

div.media-big {
  aspect-ratio: 1/1;
   flex: 0 0 300px;
  @include media(300px, 300px, 20px, true);
}

</style>
